import { RadioGroupField, BasicFilterSelectField } from 'lib/iterable-hook-form';
import { get } from 'lodash';
import { selectUserMappings } from 'modules/analytics';
import { PDFReportFormStateValues } from 'modules/messagingInsights/schema';
import { SegmentTimeFrequency } from 'modules/messagingInsights/types';
import { parseUserMappingsForDropdown } from 'modules/productAnalytics/utils';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Orientation } from 'ui/radioGroup/types';
import { UserMappings } from '../../Audience/types';
import { AudienceFormFieldContainer } from './Styled';

type Props = {
  fieldName: string;
  fieldPlaceholder: string;
  secondaryFieldName: string;
};

export const AudienceFormField = ({ fieldName, secondaryFieldName, fieldPlaceholder }: Props) => {
  const userMappings: UserMappings = useSelector(selectUserMappings as any);
  const segmentOptions = parseUserMappingsForDropdown(userMappings);
  const {
    formState: { errors },
  } = useFormContext<PDFReportFormStateValues>();
  const [selectedSegment] = useWatch({
    name: [fieldName],
  });

  const errorText = get(errors, `${fieldName}.name.message`, '').toString();
  const hasError = !!get(errors, fieldName);

  return (
    <AudienceFormFieldContainer
      data-test="audience-settings"
      errorText={errorText}
      hasError={hasError}
    >
      <BasicFilterSelectField
        name={fieldName}
        options={segmentOptions}
        placeholder={fieldPlaceholder}
      />
      {selectedSegment?.type === 'date' && (
        <RadioGroupField
          name={secondaryFieldName}
          orientation={Orientation.HORIZONTAL}
          options={[
            {
              id: SegmentTimeFrequency.WEEKLY,
              value: SegmentTimeFrequency.WEEKLY,
              label: 'Weekly',
            },
            {
              id: SegmentTimeFrequency.MONTHLY,
              value: SegmentTimeFrequency.MONTHLY,
              label: 'Monthly',
            },
            {
              id: SegmentTimeFrequency.QUARTERLY,
              value: SegmentTimeFrequency.QUARTERLY,
              label: 'Quarterly',
            },
          ]}
        />
      )}
    </AudienceFormFieldContainer>
  );
};
